import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../Header/Header1";
import Footer from "../Footer/footer";
import Sidebar from "../SideBar/SideBar";
import {
  Box,
  Stepper,
  Step,
  StepLabel,
  Button,
  Typography,
  Grid,
  TextField,
  StepIconProps,
} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import RefreshIcon from "@mui/icons-material/Refresh";
import DeleteIcon from "@mui/icons-material/Delete";
import Select from "react-select";
import "country-flag-icons/react/3x2"; // Import flag styles
import { Padding } from "@mui/icons-material";
import { Controller, useForm } from "react-hook-form";
import { toast, ToastContainer } from "react-toastify";
import usercalls from "../../Axios";
import consts from "../../constant";
import axios from "axios";
import Loader from "../Loader";
import Footernew from "../Footer/Footernew";

const countryOptions = [
  {
    "value": "AF",
    "label": "🇦🇫 Afghanistan",
    "name": "Afghanistan"
  },
  {
    "value": "AL",
    "label": "🇦🇱 Albania",
    "name": "Albania"
  },
  {
    "value": "DZ",
    "label": "🇩🇿 Algeria",
    "name": "Algeria"
  },
  {
    "value": "AD",
    "label": "🇦🇩 Andorra",
    "name": "Andorra"
  },
  {
    "value": "AO",
    "label": "🇦🇴 Angola",
    "name": "Angola"
  },
  {
    "value": "AG",
    "label": "🇦🇬 Antigua and Barbuda",
    "name": "Antigua and Barbuda"
  },
  {
    "value": "AR",
    "label": "🇦🇷 Argentina",
    "name": "Argentina"
  },
  {
    "value": "AM",
    "label": "🇦🇲 Armenia",
    "name": "Armenia"
  },
  {
    "value": "AU",
    "label": "🇦🇺 Australia",
    "name": "Australia"
  },
  {
    "value": "AT",
    "label": "🇦🇹 Austria",
    "name": "Austria"
  },
  {
    "value": "AZ",
    "label": "🇦🇿 Azerbaijan",
    "name": "Azerbaijan"
  },
  {
    "value": "BS",
    "label": "🇧🇸 Bahamas",
    "name": "Bahamas"
  },
  {
    "value": "BH",
    "label": "🇧🇭 Bahrain",
    "name": "Bahrain"
  },
  {
    "value": "BD",
    "label": "🇧🇩 Bangladesh",
    "name": "Bangladesh"
  },
  {
    "value": "BB",
    "label": "🇧🇧 Barbados",
    "name": "Barbados"
  },
  {
    "value": "BY",
    "label": "🇧🇾 Belarus",
    "name": "Belarus"
  },
  {
    "value": "BE",
    "label": "🇧🇪 Belgium",
    "name": "Belgium"
  },
  {
    "value": "BZ",
    "label": "🇧🇿 Belize",
    "name": "Belize"
  },
  {
    "value": "BJ",
    "label": "🇧🇯 Benin",
    "name": "Benin"
  },
  {
    "value": "BT",
    "label": "🇧🇹 Bhutan",
    "name": "Bhutan"
  },
  {
    "value": "BA",
    "label": "🇧🇦 Bosnia and Herzegovina",
    "name": "Bosnia and Herzegovina"
  },
  {
    "value": "BW",
    "label": "🇧🇼 Botswana",
    "name": "Botswana"
  },
  {
    "value": "BR",
    "label": "🇧🇷 Brazil",
    "name": "Brazil"
  },
  {
    "value": "BG",
    "label": "🇧🇬 Bulgaria",
    "name": "Bulgaria"
  },
  {
    "value": "BF",
    "label": "🇧🇫 Burkina Faso",
    "name": "Burkina Faso"
  },
  {
    "value": "BI",
    "label": "🇧🇮 Burundi",
    "name": "Burundi"
  },
  {
    "value": "CV",
    "label": "🇨🇻 Cabo Verde",
    "name": "Cabo Verde"
  },
  {
    "value": "KH",
    "label": "🇰🇭 Cambodia",
    "name": "Cambodia"
  },
  {
    "value": "CM",
    "label": "🇨🇲 Cameroon",
    "name": "Cameroon"
  },
  {
    "value": "CA",
    "label": "🇨🇦 Canada",
    "name": "Canada"
  },
  {
    "value": "CF",
    "label": "🇨🇫 Central African Republic",
    "name": "Central African Republic"
  },
  {
    "value": "TD",
    "label": "🇹🇩 Chad",
    "name": "Chad"
  },
  {
    "value": "CL",
    "label": "🇨🇱 Chile",
    "name": "Chile"
  },
  {
    "value": "CN",
    "label": "🇨🇳 China",
    "name": "China"
  },
  {
    "value": "CO",
    "label": "🇨🇴 Colombia",
    "name": "Colombia"
  },
  {
    "value": "KM",
    "label": "🇰🇲 Comoros",
    "name": "Comoros"
  },
  {
    "value": "CR",
    "label": "🇨🇷 Costa Rica",
    "name": "Costa Rica"
  },
  {
    "value": "HR",
    "label": "🇭🇷 Croatia",
    "name": "Croatia"
  },
  {
    "value": "CU",
    "label": "🇨🇺 Cuba",
    "name": "Cuba"
  },
  {
    "value": "CY",
    "label": "🇨🇾 Cyprus",
    "name": "Cyprus"
  },
  {
    "value": "CZ",
    "label": "🇨🇿 Czech Republic",
    "name": "Czech Republic"
  },
  {
    "value": "DK",
    "label": "🇩🇰 Denmark",
    "name": "Denmark"
  },
  {
    "value": "DJ",
    "label": "🇩🇯 Djibouti",
    "name": "Djibouti"
  },
  {
    "value": "DM",
    "label": "🇩🇲 Dominica",
    "name": "Dominica"
  },
  {
    "value": "DO",
    "label": "🇩🇴 Dominican Republic",
    "name": "Dominican Republic"
  },
  {
    "value": "EC",
    "label": "🇪🇨 Ecuador",
    "name": "Ecuador"
  },
  {
    "value": "EG",
    "label": "🇪🇬 Egypt",
    "name": "Egypt"
  },
  {
    "value": "SV",
    "label": "🇸🇻 El Salvador",
    "name": "El Salvador"
  },
  {
    "value": "GQ",
    "label": "🇬🇶 Equatorial Guinea",
    "name": "Equatorial Guinea"
  },
  {
    "value": "ER",
    "label": "🇪🇷 Eritrea",
    "name": "Eritrea"
  },
  {
    "value": "EE",
    "label": "🇪🇪 Estonia",
    "name": "Estonia"
  },
  {
    "value": "ET",
    "label": "🇪🇹 Ethiopia",
    "name": "Ethiopia"
  },
  {
    "value": "FJ",
    "label": "🇫🇯 Fiji",
    "name": "Fiji"
  },
  {
    "value": "FI",
    "label": "🇫🇮 Finland",
    "name": "Finland"
  },
  {
    "value": "FR",
    "label": "🇫🇷 France",
    "name": "France"
  },
  {
    "value": "GA",
    "label": "🇬🇦 Gabon",
    "name": "Gabon"
  },
  {
    "value": "GM",
    "label": "🇬🇲 Gambia",
    "name": "Gambia"
  },
  {
    "value": "GE",
    "label": "🇬🇪 Georgia",
    "name": "Georgia"
  },
  {
    "value": "DE",
    "label": "🇩🇪 Germany",
    "name": "Germany"
  },
  {
    "value": "GH",
    "label": "🇬🇭 Ghana",
    "name": "Ghana"
  },
  {
    "value": "GR",
    "label": "🇬🇷 Greece",
    "name": "Greece"
  },
  {
    "value": "GD",
    "label": "🇬🇩 Grenada",
    "name": "Grenada"
  },
  {
    "value": "GT",
    "label": "🇬🇹 Guatemala",
    "name": "Guatemala"
  },
  {
    "value": "GN",
    "label": "🇬🇳 Guinea",
    "name": "Guinea"
  },
  {
    "value": "GW",
    "label": "🇬🇼 Guinea-Bissau",
    "name": "Guinea-Bissau"
  },
  {
    "value": "GY",
    "label": "🇬🇾 Guyana",
    "name": "Guyana"
  },
  {
    "value": "HT",
    "label": "🇭🇹 Haiti",
    "name": "Haiti"
  },
  {
    "value": "HN",
    "label": "🇭🇳 Honduras",
    "name": "Honduras"
  },
  {
    "value": "HU",
    "label": "🇭🇺 Hungary",
    "name": "Hungary"
  },
  {
    "value": "IS",
    "label": "🇮🇸 Iceland",
    "name": "Iceland"
  },
  {
    "value": "IN",
    "label": "🇮🇳 India",
    "name": "India"
  },
  {
    "value": "ID",
    "label": "🇮🇩 Indonesia",
    "name": "Indonesia"
  },
  {
    "value": "IQ",
    "label": "🇮🇶 Iraq",
    "name": "Iraq"
  },
  {
    "value": "IE",
    "label": "🇮🇪 Ireland",
    "name": "Ireland"
  },
  {
    "value": "IL",
    "label": "🇮🇱 Israel",
    "name": "Israel"
  },
  {
    "value": "IT",
    "label": "🇮🇹 Italy",
    "name": "Italy"
  },
  {
    "value": "JM",
    "label": "🇯🇲 Jamaica",
    "name": "Jamaica"
  },
  {
    "value": "JP",
    "label": "🇯🇵 Japan",
    "name": "Japan"
  },
  {
    "value": "JO",
    "label": "🇯🇴 Jordan",
    "name": "Jordan"
  },
  {
    "value": "KZ",
    "label": "🇰🇿 Kazakhstan",
    "name": "Kazakhstan"
  },
  {
    "value": "KE",
    "label": "🇰🇪 Kenya",
    "name": "Kenya"
  },
  {
    "value": "KI",
    "label": "🇰🇮 Kiribati",
    "name": "Kiribati"
  },
  {
    "value": "KW",
    "label": "🇰🇼 Kuwait",
    "name": "Kuwait"
  },
  {
    "value": "KG",
    "label": "🇰🇬 Kyrgyzstan",
    "name": "Kyrgyzstan"
  },
  {
    "value": "LV",
    "label": "🇱🇻 Latvia",
    "name": "Latvia"
  },
  {
    "value": "LB",
    "label": "🇱🇧 Lebanon",
    "name": "Lebanon"
  },
  {
    "value": "LS",
    "label": "🇱🇸 Lesotho",
    "name": "Lesotho"
  },
  {
    "value": "LR",
    "label": "🇱🇷 Liberia",
    "name": "Liberia"
  },
  {
    "value": "LY",
    "label": "🇱🇾 Libya",
    "name": "Libya"
  },
  {
    "value": "LI",
    "label": "🇱🇮 Liechtenstein",
    "name": "Liechtenstein"
  },
  {
    "value": "LT",
    "label": "🇱🇹 Lithuania",
    "name": "Lithuania"
  },
  {
    "value": "LU",
    "label": "🇱🇺 Luxembourg",
    "name": "Luxembourg"
  },
  {
    "value": "MG",
    "label": "🇲🇬 Madagascar",
    "name": "Madagascar"
  },
  {
    "value": "MW",
    "label": "🇲🇼 Malawi",
    "name": "Malawi"
  },
  {
    "value": "MY",
    "label": "🇲🇾 Malaysia",
    "name": "Malaysia"
  },
  {
    "value": "MV",
    "label": "🇲🇻 Maldives",
    "name": "Maldives"
  },
  {
    "value": "ML",
    "label": "🇲🇱 Mali",
    "name": "Mali"
  },
  {
    "value": "MT",
    "label": "🇲🇹 Malta",
    "name": "Malta"
  },
  {
    "value": "MH",
    "label": "🇲🇭 Marshall Islands",
    "name": "Marshall Islands"
  },
  {
    "value": "MR",
    "label": "🇲🇷 Mauritania",
    "name": "Mauritania"
  },
  {
    "value": "MU",
    "label": "🇲🇺 Mauritius",
    "name": "Mauritius"
  },
  {
    "value": "MX",
    "label": "🇲🇽 Mexico",
    "name": "Mexico"
  },
  {
    "value": "MD",
    "label": "🇲🇩 Moldova",
    "name": "Moldova"
  },
  {
    "value": "MC",
    "label": "🇲🇨 Monaco",
    "name": "Monaco"
  },
  {
    "value": "MN",
    "label": "🇲🇳 Mongolia",
    "name": "Mongolia"
  },
  {
    "value": "ME",
    "label": "🇲🇪 Montenegro",
    "name": "Montenegro"
  },
  {
    "value": "MA",
    "label": "🇲🇦 Morocco",
    "name": "Morocco"
  },
  {
    "value": "MZ",
    "label": "🇲🇿 Mozambique",
    "name": "Mozambique"
  },
  {
    "value": "NA",
    "label": "🇳🇦 Namibia",
    "name": "Namibia"
  },
  {
    "value": "NR",
    "label": "🇳🇷 Nauru",
    "name": "Nauru"
  },
  {
    "value": "NP",
    "label": "🇳🇵 Nepal",
    "name": "Nepal"
  },
  {
    "value": "NL",
    "label": "🇳🇱 Netherlands",
    "name": "Netherlands"
  },
  {
    "value": "NZ",
    "label": "🇳🇿 New Zealand",
    "name": "New Zealand"
  },
  {
    "value": "NI",
    "label": "🇳🇮 Nicaragua",
    "name": "Nicaragua"
  },
  {
    "value": "NE",
    "label": "🇳🇪 Niger",
    "name": "Niger"
  },
  {
    "value": "NG",
    "label": "🇳🇬 Nigeria",
    "name": "Nigeria"
  },
  {
    "value": "KP",
    "label": "🇰🇵 North Korea",
    "name": "North Korea"
  },
  {
    "value": "MK",
    "label": "🇲🇰 North Macedonia",
    "name": "North Macedonia"
  },
  {
    "value": "NO",
    "label": "🇳🇴 Norway",
    "name": "Norway"
  },
  {
    "value": "OM",
    "label": "🇴🇲 Oman",
    "name": "Oman"
  },
  {
    "value": "PK",
    "label": "🇵🇰 Pakistan",
    "name": "Pakistan"
  },
  {
    "value": "PW",
    "label": "🇵🇼 Palau",
    "name": "Palau"
  },
  {
    "value": "PA",
    "label": "🇵🇦 Panama",
    "name": "Panama"
  },
  {
    "value": "PG",
    "label": "🇵🇬 Papua New Guinea",
    "name": "Papua New Guinea"
  },
  {
    "value": "PY",
    "label": "🇵🇾 Paraguay",
    "name": "Paraguay"
  },
  {
    "value": "PE",
    "label": "🇵🇪 Peru",
    "name": "Peru"
  },
  {
    "value": "PH",
    "label": "🇵🇭 Philippines",
    "name": "Philippines"
  },
  {
    "value": "PL",
    "label": "🇵🇱 Poland",
    "name": "Poland"
  },
  {
    "value": "PT",
    "label": "🇵🇹 Portugal",
    "name": "Portugal"
  },
  {
    "value": "QA",
    "label": "🇶🇦 Qatar",
    "name": "Qatar"
  },
  {
    "value": "RO",
    "label": "🇷🇴 Romania",
    "name": "Romania"
  },
  {
    "value": "RU",
    "label": "🇷🇺 Russia",
    "name": "Russia"
  },
  {
    "value": "RW",
    "label": "🇷🇼 Rwanda",
    "name": "Rwanda"
  },
  {
    "value": "KN",
    "label": "🇰🇳 Saint Kitts and Nevis",
    "name": "Saint Kitts and Nevis"
  },
  {
    "value": "LC",
    "label": "🇱🇨 Saint Lucia",
    "name": "Saint Lucia"
  },
  {
    "value": "VC",
    "label": "🇻🇨 Saint Vincent and the Grenadines",
    "name": "Saint Vincent and the Grenadines"
  },
  {
    "value": "WS",
    "label": "🇼🇸 Samoa",
    "name": "Samoa"
  },
  {
    "value": "SM",
    "label": "🇸🇲 San Marino",
    "name": "San Marino"
  },
  {
    "value": "ST",
    "label": "🇸🇹 Sao Tome and Principe",
    "name": "Sao Tome and Principe"
  },
  {
    "value": "SA",
    "label": "🇸🇦 Saudi Arabia",
    "name": "Saudi Arabia"
  },
  {
    "value": "SN",
    "label": "🇸🇳 Senegal",
    "name": "Senegal"
  },
  {
    "value": "RS",
    "label": "🇷🇸 Serbia",
    "name": "Serbia"
  },
  {
    "value": "SC",
    "label": "🇸🇨 Seychelles",
    "name": "Seychelles"
  },
  {
    "value": "SL",
    "label": "🇸🇱 Sierra Leone",
    "name": "Sierra Leone"
  },
  {
    "value": "SG",
    "label": "🇸🇬 Singapore",
    "name": "Singapore"
  },
  {
    "value": "SK",
    "label": "🇸🇰 Slovakia",
    "name": "Slovakia"
  },
  {
    "value": "SI",
    "label": "🇸🇮 Slovenia",
    "name": "Slovenia"
  },
  {
    "value": "SB",
    "label": "🇸🇧 Solomon Islands",
    "name": "Solomon Islands"
  },
  {
    "value": "SO",
    "label": "🇸🇴 Somalia",
    "name": "Somalia"
  },
  {
    "value": "ZA",
    "label": "🇿🇦 South Africa",
    "name": "South Africa"
  },
  {
    "value": "KR",
    "label": "🇰🇷 South Korea",
    "name": "South Korea"
  },
  {
    "value": "SS",
    "label": "🇸🇸 South Sudan",
    "name": "South Sudan"
  },
  {
    "value": "ES",
    "label": "🇪🇸 Spain",
    "name": "Spain"
  },
  {
    "value": "LK",
    "label": "🇱🇰 Sri Lanka",
    "name": "Sri Lanka"
  },
  {
    "value": "SD",
    "label": "🇸🇩 Sudan",
    "name": "Sudan"
  },
  {
    "value": "SR",
    "label": "🇸🇷 Suriname",
    "name": "Suriname"
  },
  {
    "value": "SE",
    "label": "🇸🇪 Sweden",
    "name": "Sweden"
  },
  {
    "value": "CH",
    "label": "🇨🇭 Switzerland",
    "name": "Switzerland"
  },
  {
    "value": "SY",
    "label": "🇸🇾 Syria",
    "name": "Syria"
  },
  {
    "value": "TJ",
    "label": "🇹🇯 Tajikistan",
    "name": "Tajikistan"
  },
  {
    "value": "TZ",
    "label": "🇹🇿 Tanzania",
    "name": "Tanzania"
  },
  {
    "value": "TH",
    "label": "🇹🇭 Thailand",
    "name": "Thailand"
  },
  {
    "value": "TL",
    "label": "🇹🇱 Timor-Leste",
    "name": "Timor-Leste"
  },
  {
    "value": "TG",
    "label": "🇹🇬 Togo",
    "name": "Togo"
  },
  {
    "value": "TO",
    "label": "🇹🇴 Tonga",
    "name": "Tonga"
  },
  {
    "value": "TT",
    "label": "🇹🇹 Trinidad and Tobago",
    "name": "Trinidad and Tobago"
  },
  {
    "value": "TN",
    "label": "🇹🇳 Tunisia",
    "name": "Tunisia"
  },
  {
    "value": "TR",
    "label": "🇹🇷 Turkey",
    "name": "Turkey"
  },
  {
    "value": "TM",
    "label": "🇹🇲 Turkmenistan",
    "name": "Turkmenistan"
  },
  {
    "value": "TV",
    "label": "🇹🇻 Tuvalu",
    "name": "Tuvalu"
  },
  {
    "value": "UG",
    "label": "🇺🇬 Uganda",
    "name": "Uganda"
  },
  {
    "value": "UA",
    "label": "🇺🇦 Ukraine",
    "name": "Ukraine"
  },
  {
    "value": "AE",
    "label": "🇦🇪 United Arab Emirates",
    "name": "United Arab Emirates"
  },
  {
    "value": "GB",
    "label": "🇬🇧 United Kingdom",
    "name": "United Kingdom"
  },
  {
    "value": "US",
    "label": "🇺🇸 United States",
    "name": "United States"
  },
  {
    "value": "UY",
    "label": "🇺🇾 Uruguay",
    "name": "Uruguay"
  },
  {
    "value": "UZ",
    "label": "🇺🇿 Uzbekistan",
    "name": "Uzbekistan"
  },
  {
    "value": "VU",
    "label": "🇻🇺 Vanuatu",
    "name": "Vanuatu"
  },
  {
    "value": "VE",
    "label": "🇻🇪 Venezuela",
    "name": "Venezuela"
  },
  {
    "value": "VN",
    "label": "🇻🇳 Vietnam",
    "name": "Vietnam"
  },
  {
    "value": "YE",
    "label": "🇾🇪 Yemen",
    "name": "Yemen"
  },
  {
    "value": "ZM",
    "label": "🇿🇲 Zambia",
    "name": "Zambia"
  },
  {
    "value": "ZW",
    "label": "🇿🇼 Zimbabwe",
    "name": "Zimbabwe"
  }
]

const steps = ["Aadhaar Verification", "PAN Verification", "Selfie Photo"];

const options = [
  { value: "apple", label: "Apple" },
  { value: "banana", label: "Banana" },
  { value: "cherry", label: "Cherry" },
];

// 🎨 Custom Styles for White Text and Background
const customStyles = {
  control: (provided) => ({
    ...provided,
    backgroundColor: "var(--clr-bcg)", // White background
    padding: "8px",
    color: "var(--clr-font)", // Text color inside input
    borderColor: "#ccc",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "var(--clr-font)", // Selected text color
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: "var(--clr-bcg)", // Dropdown background
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: "#fff", // Selected and normal state
    color: "#000", // Text color
    "&:hover": {
      backgroundColor: "#f0f0f0", // Hover effect
    },
  }),
};

export default function Kycverify() {
  const [frontimage, setfrontimage] = useState(null);
  const [backimage, setbackimage] = useState(null);

  const [idProof, setIdProof] = useState(null);
  const [singleImg, setSingleImg] = useState(null);

  const navigate = useNavigate();
  const [address_proof, setAddress_proof] = useState("");

  const [ID_Image_front, SetID_Image_front] = useState("");

  const [ID_Image_Back, SetID_Image_Back] = useState("");

  const path = usercalls();

  const [load, setLoad] = useState(false);

  const [focused, setFocused] = useState(false);

  // Handle the change in file input (on file selection)
  const handleFileChangeIdproof = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file); // Generate image URL
      setIdProof(imageUrl); // Set the image URL to the state
      var url = `${consts.BackendUrl}/users/imageUpload`;
      var payload = new FormData();
      payload.append("image", file);
      const result = await axios.post(url, payload, {
        headers: {
          Authorization: localStorage.getItem("Rikosta"),
        },
      });
      // console.log(result, "result");
      setAddress_proof(result?.data?.result);
    }
  };

  // Handle the change in file input (on file selection)
  const handleFileChangeSingleImg = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file); // Generate image URL
      setSingleImg(imageUrl); // Set the image URL to the state
      var url = `${consts.BackendUrl}/users/imageUpload`;
      var payload = new FormData();
      payload.append("image", file);
      const result = await axios.post(url, payload, {
        headers: {
          Authorization: localStorage.getItem("Rikosta"),
        },
      });
      SetID_Image_front(result?.data?.result);
    }
  };

  // Handle the change in file input (on file selection)
  const handleFileChangeFront = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file); // Generate image URL
      setfrontimage(imageUrl); // Set the image URL to the state
      var url = `${consts.BackendUrl}/users/imageUpload`;
      var payload = new FormData();
      payload.append("image", file);
      const result = await axios.post(url, payload, {
        headers: {
          Authorization: localStorage.getItem("Rikosta"),
        },
      });
      SetID_Image_front(result?.data?.result);
    }
  };

  // Handle the change in file input (on file selection)
  const handleFileChangeBack = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file); // Generate image URL
      setbackimage(imageUrl); // Set the image URL to the state
      var url = `${consts.BackendUrl}/users/imageUpload`;
      var payload = new FormData();
      payload.append("image", file);
      const result = await axios.post(url, payload, {
        headers: {
          Authorization: localStorage.getItem("Rikosta"),
        },
      });
      SetID_Image_Back(result?.data?.result);
    }
  };

  const [proofDoc, setProofDoc] = useState("");
  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm({});
  const [kycDetails, setKycDetails] = useState("");

  // const [loading, setLoading] = useState(false);

  const getKyc = async () => {
    try {
      setLoad(true);
      const url = `${consts.BackendUrl}/getKyc`;
      const payload = {};
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      // console.log(result, "resultresult")
      if (result?.result) {
        setKycDetails(result?.result);
        setLoad(false);
      }
      setLoad(false);
    } catch (error) {
      console.log(error, "error");
    }
  };

  useEffect(() => {
    getKyc();
  }, []);

  const onSubmit = async (data) => {
    if (!address_proof) return toast.error("Please Upload Address Proof");
    if (!proofDoc) return toast.error("Please Select Proof Document Type");
    if (proofDoc == "Passport" && ID_Image_front == "")
      return toast.error("Please Upload Front ID");
    if (proofDoc == "NationalId" && ID_Image_front == "")
      return toast.error("Please Upload Front ID");
    if (proofDoc == "NationalId" && ID_Image_Back == "")
      return toast.error("Please Upload Back ID");

    setLoad(true);
    var country = data?.country?.name;
    delete data?.country;
    var payload = {
      address_proof: address_proof,
      ID_country: country,
      ID_type: proofDoc,
      ID_Image_front: ID_Image_front,
      ID_Image_Back: ID_Image_Back,
      // ID_Image_front: 'http://13.61.165.12/Dreamster-Exapi/images/kerisha_1738855493351.jpeg',
      // ID_Image_Back: ID_Image_Back,
      Country: country,
      ...data,
    };
    // console.log(payload, "payload");

    const url = `${consts.BackendUrl}/uploadKyc`;
    const response = await path.postCall({ url, payload });
    const result = await response.json();
    // console.log(result, "resultresult")
    if (result?.success == false) {
      toast.error(result?.message);
    } else {
      toast.success("KYC details Submitted!");
      // console.log(result, "urlurl");
      getKyc();
      // navigate(result?.result)
      // window.location.href = result?.result
    }
    setLoad(false);
  };

  return (
    <div>
      <Header />
      {load && <Loader />}
      <div className="main_flx">
        <Sidebar />
        <div style={{ width: "100%" }}>
          <div className="abvbar split_half" style={{ position: 'relative' }}>
            <div className="border-ky-he">
              <h6> Kyc Verification</h6>
            </div>
          </div>

          {kycDetails == "" ? (
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="kyc-banner">
                <Grid container spacing={2} sx={{ paddingRight: "16px", paddingLeft: '16px' }}>
                  <Grid item xl={6} lg={6} md={6} sm={12} xs={12} >
                    <div className="kyc-inp">
                      <TextField
                        id="outlined-basic"
                        placeholder="Name"
                        variant="outlined"
                        {...register("Firstname", {
                          required: "Firstname is required",
                        })}
                        error={!!errors.Firstname}
                        helperText={
                          errors.Firstname ? errors.Firstname.message : ""
                        }
                      />
                    </div>
                  </Grid>
                  <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                    <div className="kyc-inp">
                      <TextField
                        id="outlined-basic"
                        placeholder="Sur Name"
                        variant="outlined"
                        {...register("Lastname", {
                          required: "Lastname is required",
                        })}
                        error={!!errors.Lastname}
                        helperText={
                          errors.Lastname ? errors.Lastname.message : ""
                        }
                      />
                    </div>
                  </Grid>
                  <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                    <div className="kyc-inp">
                      <TextField
                        id="outlined-basic"
                        placeholder="Email"
                        variant="outlined"
                        {...register("email", {
                          required: "Email is required",
                          pattern: {
                            value:
                              /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                            message: "Invalid email address",
                          },
                        })}
                        error={!!errors.email}
                        helperText={errors.email ? errors.email.message : ""}
                      />
                    </div>
                  </Grid>
                  <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                    <div className="kyc-inp">
                      <TextField
                        id="outlined-basic"
                        placeholder="Phone"
                        variant="outlined"
                        type="number"
                        {...register("phone", {
                          required: "phone is required",
                        })}
                        error={!!errors.phone}
                        helperText={errors.phone ? errors.phone.message : ""}
                      />
                    </div>
                  </Grid>
                  <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                    <div className="kyc-inp">
                      <TextField
                        id="dob"
                        name="dob"
                        type={focused ? "date" : "text"}
                        label=""
                        placeholder="DOB"
                        variant="outlined"
                        onFocus={() => setFocused(true)}
                        onBlur={(e) => {
                          if (!e.target.value) setFocused(false);
                        }}
                        sx={{
                          "& input": {
                            color: "var(--clr-font)",
                          },
                          "& input::placeholder": {
                            color: "var(--inpu-lable)",
                            opacity: 1,
                          },
                          "& input[type='date']::-webkit-calendar-picker-indicator": {
                            filter: "invert(70%)",
                          },
                          "&:hover fieldset": {
                            borderColor: "#fff",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#fff",
                          },
                        }}
                        {...register("dob", { required: "DOB is required" })}
                        error={!!errors.dob}
                        helperText={errors.dob ? errors.dob.message : ""}
                      />

                    </div>
                  </Grid>
                  <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                    <div className="kyc-inp">
                      <TextField
                        id="outlined-basic"
                        placeholder="City"
                        variant="outlined"
                        {...register("city", { required: "city is required" })}
                        error={!!errors.city}
                        helperText={errors.city ? errors.city.message : ""}
                      />
                    </div>
                  </Grid>
                  <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                    <div className="kyc-inp">
                      <TextField
                        id="outlined-basic"
                        placeholder="State"
                        variant="outlined"
                        {...register("stateOrProvince", {
                          required: "stateOrProvince is required",
                        })}
                        error={!!errors.stateOrProvince}
                        helperText={
                          errors.stateOrProvince
                            ? errors.stateOrProvince.message
                            : ""
                        }
                      />
                    </div>
                  </Grid>
                  <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                    <Controller
                      name="country"
                      control={control}
                      defaultValue=""
                      rules={{ required: "Country is required" }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={countryOptions}
                          placeholder="Select Country"
                          styles={customStyles}
                        />
                      )}
                    />
                    {/* <Select options={countryOptions}  styles={customStyles} placeholder="Select Country" /> */}
                  </Grid>
                  <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                    <div className="kyc-inp">
                      <TextField
                        id="outlined-basic"
                        placeholder="Zip Code/Postal"
                        variant="outlined"
                        type="text"
                        {...register("postalcode", {
                          required: "postalcode is required",
                        })}
                        error={!!errors.postalcode}
                        helperText={
                          errors.postalcode ? errors.postalcode.message : ""
                        }
                      />
                    </div>
                  </Grid>

                  <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                    <div className="kyc-inp">
                      <TextField
                        id="outlined-multiline-static"
                        placeholder="Address Line 1*"
                        multiline
                        rows={4}
                        //   defaultValue="Default Value"
                        {...register("address_line1", {
                          required: "address_line1 is required",
                        })}
                        error={!!errors.address_line1}
                        helperText={
                          errors.address_line1
                            ? errors.address_line1.message
                            : ""
                        }
                      />
                    </div>
                  </Grid>

                  <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                    <div className="kyc-inp">
                      <TextField
                        id="outlined-multiline-static"
                        placeholder="Address Line 2"
                        multiline
                        rows={4}
                        // defaultValue="Default Value"
                        {...register("address_line2")}
                        error={!!errors.address_line2}
                        helperText={
                          errors.address_line2
                            ? errors.address_line2.message
                            : ""
                        }
                      />
                    </div>
                  </Grid>

                  <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                    <div className="">
                      <div className="h6split ">Address Proof</div>

                      <label for="file1" class="custum-file-upload">
                        {idProof ? (
                          <>
                            <div className="fol-us">
                              <div className="">
                                <RefreshIcon />
                                <input
                                  id="file1"
                                  type="file"
                                  onChange={(e) => {
                                    handleFileChangeIdproof(e);
                                  }}
                                />
                              </div>
                              <div className="">
                                <DeleteIcon
                                  onClick={() => {
                                    setIdProof(null);
                                  }}
                                />
                              </div>
                            </div>
                            <img
                              src={idProof}
                              alt="frontimage"
                              className="frnt-img"
                            />
                          </>
                        ) : (
                          <>
                            <div class="icon">
                              <svg
                                viewBox="0 0 24 24"
                                fill=""
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                <g
                                  id="SVGRepo_tracerCarrier"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                ></g>
                                <g id="SVGRepo_iconCarrier">
                                  {" "}
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M10 1C9.73478 1 9.48043 1.10536 9.29289 1.29289L3.29289 7.29289C3.10536 7.48043 3 7.73478 3 8V20C3 21.6569 4.34315 23 6 23H7C7.55228 23 8 22.5523 8 22C8 21.4477 7.55228 21 7 21H6C5.44772 21 5 20.5523 5 20V9H10C10.5523 9 11 8.55228 11 8V3H18C18.5523 3 19 3.44772 19 4V9C19 9.55228 19.4477 10 20 10C20.5523 10 21 9.55228 21 9V4C21 2.34315 19.6569 1 18 1H10ZM9 7H6.41421L9 4.41421V7ZM14 15.5C14 14.1193 15.1193 13 16.5 13C17.8807 13 19 14.1193 19 15.5V16V17H20C21.1046 17 22 17.8954 22 19C22 20.1046 21.1046 21 20 21H13C11.8954 21 11 20.1046 11 19C11 17.8954 11.8954 17 13 17H14V16V15.5ZM16.5 11C14.142 11 12.2076 12.8136 12.0156 15.122C10.2825 15.5606 9 17.1305 9 19C9 21.2091 10.7909 23 13 23H20C22.2091 23 24 21.2091 24 19C24 17.1305 22.7175 15.5606 20.9844 15.122C20.7924 12.8136 18.858 11 16.5 11Z"
                                    fill=""
                                  ></path>{" "}
                                </g>
                              </svg>
                            </div>
                            <div class="text">
                              <span>Click to upload image</span>
                            </div>
                            <input
                              id="file1"
                              type="file"
                              onChange={(e) => {
                                handleFileChangeIdproof(e);
                              }}
                            />
                          </>
                        )}
                      </label>
                    </div>
                  </Grid>

                  {proofDoc === "" && (
                    <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                      <div className="h6split ">Choose any one Document</div>
                      {
                        <div class="radio-inputs">
                          <label>
                            <input
                              class="radio-input"
                              type="radio"
                              name="engine"
                              onChange={() => {
                                setProofDoc("Passport");
                              }}
                            />
                            <span class="radio-tile">
                              <span class="radio-icon">
                                <img
                                  width="80"
                                  height="80"
                                  src="https://img.icons8.com/color/80/passport.png"
                                  alt="passport"
                                />
                              </span>
                              <span class="radio-label">Passport</span>
                            </span>
                          </label>
                          {/* <label>
    <input checked="" class="radio-input" type="radio" name="engine" />
    <span class="radio-tile">
      <span class="radio-icon">
      </span>
      <span class="radio-label">Adhaar</span>
    </span>
  </label> */}
                          <label>
                            <input
                              class="radio-input"
                              type="radio"
                              name="engine"
                              onChange={() => {
                                setProofDoc("NationalId");
                              }}
                            />
                            <span class="radio-tile">
                              <span class="radio-icon">
                                <img
                                  width="80"
                                  height="80"
                                  src="https://img.icons8.com/fluency/80/badge.png"
                                  alt="badge"
                                />
                              </span>
                              <span class="radio-label">National ID</span>
                            </span>
                          </label>
                        </div>
                      }
                    </Grid>
                  )}

                  {proofDoc === "Passport" && (
                    <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                      <Button
                        variant="contained"
                        onClick={() => {
                          setProofDoc("");
                          SetID_Image_front("");
                          SetID_Image_Back("");
                          setSingleImg("");
                          setfrontimage("");
                          setbackimage("");
                        }}
                        className="back"
                      >
                        Back
                      </Button>
                      <label for="file2" class="custum-file-upload">
                        {singleImg ? (
                          <>
                            <div className="fol-us">
                              <div className="">
                                <RefreshIcon />
                                <input
                                  id="file2"
                                  type="file"
                                  onChange={(e) => {
                                    handleFileChangeSingleImg(e);
                                  }}
                                />
                              </div>
                              <div className="">
                                <DeleteIcon
                                  onClick={() => {
                                    setSingleImg(null);
                                  }}
                                />
                              </div>
                            </div>
                            <img
                              src={singleImg}
                              alt="frontimage"
                              className="frnt-img"
                            />
                          </>
                        ) : (
                          <>
                            <div class="icon">
                              <svg
                                viewBox="0 0 24 24"
                                fill=""
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                <g
                                  id="SVGRepo_tracerCarrier"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                ></g>
                                <g id="SVGRepo_iconCarrier">
                                  {" "}
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M10 1C9.73478 1 9.48043 1.10536 9.29289 1.29289L3.29289 7.29289C3.10536 7.48043 3 7.73478 3 8V20C3 21.6569 4.34315 23 6 23H7C7.55228 23 8 22.5523 8 22C8 21.4477 7.55228 21 7 21H6C5.44772 21 5 20.5523 5 20V9H10C10.5523 9 11 8.55228 11 8V3H18C18.5523 3 19 3.44772 19 4V9C19 9.55228 19.4477 10 20 10C20.5523 10 21 9.55228 21 9V4C21 2.34315 19.6569 1 18 1H10ZM9 7H6.41421L9 4.41421V7ZM14 15.5C14 14.1193 15.1193 13 16.5 13C17.8807 13 19 14.1193 19 15.5V16V17H20C21.1046 17 22 17.8954 22 19C22 20.1046 21.1046 21 20 21H13C11.8954 21 11 20.1046 11 19C11 17.8954 11.8954 17 13 17H14V16V15.5ZM16.5 11C14.142 11 12.2076 12.8136 12.0156 15.122C10.2825 15.5606 9 17.1305 9 19C9 21.2091 10.7909 23 13 23H20C22.2091 23 24 21.2091 24 19C24 17.1305 22.7175 15.5606 20.9844 15.122C20.7924 12.8136 18.858 11 16.5 11Z"
                                    fill=""
                                  ></path>{" "}
                                </g>
                              </svg>
                            </div>
                            <div class="text">
                              <span>Click to upload Document</span>
                            </div>
                            <input
                              id="file2"
                              type="file"
                              onChange={(e) => {
                                handleFileChangeSingleImg(e);
                              }}
                            />
                          </>
                        )}
                      </label>
                      <div className="kyc-inp mt-20">
                        <TextField
                          id="outlined-basic"
                          label="ID Number"
                          variant="outlined"
                          type="text"
                          {...register("ID_Number", {
                            required: "ID_Number is required",
                          })}
                          error={!!errors.ID_Number}
                          helperText={
                            errors.ID_Number ? errors.ID_Number.message : ""
                          }
                        />
                      </div>
                    </Grid>
                  )}

                  {proofDoc === "NationalId" && (
                    <>
                      <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                        <Button
                          variant="contained"
                          onClick={() => {
                            setProofDoc("");
                            SetID_Image_front("");
                            SetID_Image_Back("");
                            setSingleImg("");
                            setfrontimage("");
                            setbackimage("");
                          }}
                          className="back"
                        >
                          Back
                        </Button>
                      </Grid>
                      <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                        <label for="file3" class="custum-file-upload">
                          {frontimage ? (
                            <>
                              <div className="fol-us">
                                <div className="">
                                  <RefreshIcon />
                                  <input
                                    id="file3"
                                    type="file"
                                    onChange={handleFileChangeFront}
                                  />
                                </div>
                                <div className="">
                                  <DeleteIcon
                                    onClick={() => {
                                      setfrontimage(null);
                                    }}
                                  />
                                </div>
                              </div>
                              <img
                                src={frontimage}
                                alt="frontimage"
                                className="frnt-img"
                              />
                            </>
                          ) : (
                            <>
                              <div class="icon">
                                <svg
                                  viewBox="0 0 24 24"
                                  fill=""
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g
                                    id="SVGRepo_bgCarrier"
                                    stroke-width="0"
                                  ></g>
                                  <g
                                    id="SVGRepo_tracerCarrier"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  ></g>
                                  <g id="SVGRepo_iconCarrier">
                                    {" "}
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M10 1C9.73478 1 9.48043 1.10536 9.29289 1.29289L3.29289 7.29289C3.10536 7.48043 3 7.73478 3 8V20C3 21.6569 4.34315 23 6 23H7C7.55228 23 8 22.5523 8 22C8 21.4477 7.55228 21 7 21H6C5.44772 21 5 20.5523 5 20V9H10C10.5523 9 11 8.55228 11 8V3H18C18.5523 3 19 3.44772 19 4V9C19 9.55228 19.4477 10 20 10C20.5523 10 21 9.55228 21 9V4C21 2.34315 19.6569 1 18 1H10ZM9 7H6.41421L9 4.41421V7ZM14 15.5C14 14.1193 15.1193 13 16.5 13C17.8807 13 19 14.1193 19 15.5V16V17H20C21.1046 17 22 17.8954 22 19C22 20.1046 21.1046 21 20 21H13C11.8954 21 11 20.1046 11 19C11 17.8954 11.8954 17 13 17H14V16V15.5ZM16.5 11C14.142 11 12.2076 12.8136 12.0156 15.122C10.2825 15.5606 9 17.1305 9 19C9 21.2091 10.7909 23 13 23H20C22.2091 23 24 21.2091 24 19C24 17.1305 22.7175 15.5606 20.9844 15.122C20.7924 12.8136 18.858 11 16.5 11Z"
                                      fill=""
                                    ></path>{" "}
                                  </g>
                                </svg>
                              </div>
                              <div class="text">
                                <span>Click to upload Front Side</span>
                              </div>
                              <input
                                id="file3"
                                type="file"
                                onChange={handleFileChangeFront}
                              />
                            </>
                          )}
                        </label>
                      </Grid>
                      <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                        <label for="file4" class="custum-file-upload">
                          {backimage ? (
                            <>
                              <div className="fol-us">
                                <div className="">
                                  <RefreshIcon />
                                  <input
                                    id="file4"
                                    type="file"
                                    onChange={handleFileChangeBack}
                                  />
                                </div>
                                <div className="">
                                  <DeleteIcon
                                    onClick={() => {
                                      setbackimage(null);
                                    }}
                                  />
                                </div>
                              </div>
                              <img
                                src={backimage}
                                alt="frontimage"
                                className="frnt-img"
                              />
                            </>
                          ) : (
                            <>
                              <div class="icon">
                                <svg
                                  viewBox="0 0 24 24"
                                  fill=""
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g
                                    id="SVGRepo_bgCarrier"
                                    stroke-width="0"
                                  ></g>
                                  <g
                                    id="SVGRepo_tracerCarrier"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  ></g>
                                  <g id="SVGRepo_iconCarrier">
                                    {" "}
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M10 1C9.73478 1 9.48043 1.10536 9.29289 1.29289L3.29289 7.29289C3.10536 7.48043 3 7.73478 3 8V20C3 21.6569 4.34315 23 6 23H7C7.55228 23 8 22.5523 8 22C8 21.4477 7.55228 21 7 21H6C5.44772 21 5 20.5523 5 20V9H10C10.5523 9 11 8.55228 11 8V3H18C18.5523 3 19 3.44772 19 4V9C19 9.55228 19.4477 10 20 10C20.5523 10 21 9.55228 21 9V4C21 2.34315 19.6569 1 18 1H10ZM9 7H6.41421L9 4.41421V7ZM14 15.5C14 14.1193 15.1193 13 16.5 13C17.8807 13 19 14.1193 19 15.5V16V17H20C21.1046 17 22 17.8954 22 19C22 20.1046 21.1046 21 20 21H13C11.8954 21 11 20.1046 11 19C11 17.8954 11.8954 17 13 17H14V16V15.5ZM16.5 11C14.142 11 12.2076 12.8136 12.0156 15.122C10.2825 15.5606 9 17.1305 9 19C9 21.2091 10.7909 23 13 23H20C22.2091 23 24 21.2091 24 19C24 17.1305 22.7175 15.5606 20.9844 15.122C20.7924 12.8136 18.858 11 16.5 11Z"
                                      fill=""
                                    ></path>{" "}
                                  </g>
                                </svg>
                              </div>
                              <div class="text">
                                <span>Click to upload Back Side</span>
                              </div>
                              <input
                                id="file4"
                                type="file"
                                onChange={handleFileChangeBack}
                              />
                            </>
                          )}
                        </label>
                      </Grid>
                      <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                        <div className="kyc-inp mt-20">
                          <TextField
                            id="outlined-basic"
                            label="ID Number"
                            variant="outlined"
                            type="number"
                            {...register("ID_Number", {
                              required: "ID_Number is required",
                            })}
                            error={!!errors.ID_Number}
                            helperText={
                              errors.ID_Number ? errors.ID_Number.message : ""
                            }
                          />
                        </div>
                      </Grid>
                    </>
                  )}
                  <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                    <div className="text-center">
                      <Button
                        variant="contained"
                        type="submit"
                        disabled={load}
                        className="back"
                      >
                        Submit
                      </Button>
                    </div>
                  </Grid>

                  {/* <!-- From Uiverse.io by Yaya12085 -->  */}
                </Grid>
              </div>
            </form>
          ) : (
            <div className="verified-div">
              {kycDetails?.status == "1" ? (
                <h1 className="text-center">Kyc Verification Failed </h1>
              ) : kycDetails?.status == "2" ? (
                <h1 className="text-center">Kyc Verified Successfully </h1>
              ) : (
                <h1 className="text-center">Waiting for Admin Verification</h1>
              )}
              <div className="display-2 p-20 gap-30">
                <div> First Name :-</div>
                <div> {kycDetails?.Firstname} </div>
              </div>

              <div className="display-2 p-20 gap-30">
                <div> Last Name :-</div>
                <div> {kycDetails?.Lastname} </div>
              </div>

              <div className="display-2 p-20 gap-30">
                <div> Email :-</div>
                <div> {kycDetails?.email} </div>
              </div>
              <div className="display-2 p-20 gap-30 mb-flex">
                <div> Phone No :-</div>
                <div> {kycDetails?.phone} </div>
              </div>
              <div className="display-2 p-20 gap-30 mb-flex">
                <div> Address Line 1 :-</div>

                <div> {kycDetails?.address_line1} </div>
              </div>

              <div className="display-2 p-20 gap-30 mb-flex">
                <div> Address Line 2 :-</div>

                <div> {kycDetails?.address_line2 ? kycDetails?.address_line2 : "-"} </div>
              </div>
              <div className="display-2 p-20 gap-30">
                <div> City :-</div>

                <div> {kycDetails?.city} </div>
              </div>
              <div className="display-2 p-20 gap-30">
                <div> State :-</div>

                <div> {kycDetails?.stateOrProvince} </div>
              </div>
              <div className="display-2 p-20 gap-30">
                <div> Country :-</div>

                <div> {kycDetails?.Country} </div>
              </div>
              <div className="display-2 p-20 gap-30">
                <div> Postal Code :-</div>

                <div> {kycDetails?.postalcode} </div>
              </div>
              <div className="display-2 p-20 gap-30 mb-flex">
                <div> Address Proof :-</div>

                <img
                  src={kycDetails?.address_proof}
                  alt="test"
                  className="verified-img"
                />
              </div>
              <div className="display-2 p-20 gap-30">
                <div> ID Tountry :-</div>

                <div> {kycDetails?.ID_country} </div>
              </div>
              <div className="display-2 p-20 gap-30">
                <div> ID Type :-</div>

                <div> {kycDetails?.ID_type} </div>
              </div>
              <div className="display-2 p-20 gap-30 mb-flex">
                <div> ID Number :-</div>

                <div> {kycDetails?.ID_Number} </div>
              </div>
              <div className="display-2 p-20 gap-30 mb-flex">
                <div> ID Image front :-</div>

                <img
                  src={kycDetails?.ID_Image_front}
                  alt="test"
                  className="verified-img"
                />
              </div>
              <div className="display-2 p-20 gap-30 mb-flex">
                <div> ID Image Back :-</div>
                {
                  kycDetails?.ID_Image_Back ?
                    <img
                      src={kycDetails?.ID_Image_Back}
                      alt="test"
                      className="verified-img"
                    />
                    : "-"
                }

              </div>
              {/* <div className="display-2 p-20 gap-30">
                <div> ID Verification :-</div>

                <div> {kycDetails?.LivenessDatas?.verify_status} </div>
              </div> */}

              {/* <div className="display-2 p-20 gap-30 mb-flex">
                <div> Liveness Verification :-</div>

                <div> {kycDetails?.status == "1" ? "Liveness Verification Failed" : kycDetails?.status == "0" ? "Livenesss Verification Failed" : "Verified"} </div>
              </div> */}
              {kycDetails?.status == "1" && (
                <div className="text-center">
                  <Button
                    onClick={() => {
                      setKycDetails("");
                    }}
                    variant="contained"
                    sx={{ bgcolor: "#566FFF !important" }}
                  >
                    ReVerify
                  </Button>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      <Footernew />
    </div>
  );
}
